<template>
  <div>
    <div class='button-line'>
      <button @click="close()">取消</button>
      <span>选择所属国家或地区</span>
      <button @click="selectSure">确定</button>
    </div>
    <mt-picker :slots="countryslot" @change="selectCountry" value-key="ch_name"></mt-picker>
  </div>
</template>

<script>
  import {ajax,setCode,setEmail} from '../../assets/js/common'
  export default{
    data(){
      return{
        pop2:true,
        areaCode:"86",
        countryslot:[
          {
            flex: 1,
            values: [],
            className: 'slot1',
            textAlign: 'center'
          },
        ],
        countryVal:{},
      }
    },
    mounted(){
      this.$nextTick(()=>{
        this.countryCheck();
      });
    },
    methods:{
      close(){
        this.$emit("closePop");
      },
      selectSure(){
        // this.pop2=false;
        // this.areaCode=this.countryVal.code;
        this.$emit("codeChange",this.countryVal.code);
      },
      /*手机国家选择*/
      selectCountry(picker, values){
        this.countryVal=values[0];
      },
      /*手机国家获取*/
      countryCheck(){
        let param={
          type:"code",
        };
        this.countryslot[0].values=[];
        console.log(this.extendApi.countryList);
        ajax(this,this.extendApi.countryList,param,(data)=>{
          if(data.code==200){
            for(let i=0;i<data.data.length;i++){
              this.countryslot[0].values.push(data.data[i]);
            }
          }
        },"GET");
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/views/login/areaBlock.vue